import ActivityIndicator from "./activity-indicator";
import Add from "./add";
import AddedToList from "./added-to-list";
import Apple from "./apple";
import Aquaclean from "./aquaclean";
import ArrowBottomLeft from "./arrow-bottom-left";
import ArrowBottomRight from "./arrow-bottom-right";
import ArrowDown from "./arrow-down";
import ArrowLeft from "./arrow-left";
import ArrowRight from "./arrow-right";
import ArrowTopLeft from "./arrow-top-left";
import ArrowTopRight from "./arrow-top-right";
import ArrowUp from "./arrow-up";
import Attachment from "./attachment";
import AvailableSeats from "./available-seats";
import Backwards from "./backwards";
import Backwards5s from "./backwards-5s";
import Bath from "./bath";
import BathPlanner from "./bath-planner";
import Battery from "./battery";
import BatteryEmpty from "./battery-empty";
import BatteryFull from "./battery-full";
import BatteryLow from "./battery-low";
import BatteryOk from "./battery-ok";
import Bluetooth from "./bluetooth";
import BmsSmartHome from "./bms-smart-home";
import BookmarkFilled from "./bookmark-filled";
import BookmarkOutlined from "./bookmark-outlined";
import BrightnessMax from "./brightnessMax";
import BrightnessMin from "./brightnessMin";
import Brush from "./brush";
import CAD from "./cad";
import Calendar from "./calendar";
import Catalogue from "./catalogue";
import Categories from "./categories";
import CategorySelect from "./category-select";
import CellularNetwork from "./cellular-network";
import Chat from "./chat";
import Checklist from "./checklist";
import Checkmark from "./checkmark";
import CheckmarkFilled from "./checkmark-filled";
import ChevronDown from "./chevron-down";
import ChevronDownFlat from "./chevron-down-flat";
import ChevronLeft from "./chevron-left";
import ChevronLeftFlat from "./chevron-left-flat";
import ChevronRight from "./chevron-right";
import ChevronRightFlat from "./chevron-right-flat";
import ChevronUp from "./chevron-up";
import ChevronUpFlat from "./chevron-up-flat";
import Cleaning from "./cleaning";
import Clock from "./clock";
import Close from "./close";
import Cloud from "./cloud";
import ContentCopy from "./content-copy";
import ContentPaste from "./content-paste";
import Converter from "./converter";
import CostPerPerson from "./cost-per-person";
import CreateGroup from "./create-group";
import CsvFile from "./csv-file";
import Cut from "./cut";
import Datapoints from "./datapoints";
import Descaling from "./descaling";
import DislikeFilled from "./dislike-filled";
import DislikeOutlined from "./dislike-outlined";
import Document from "./document";
import DoubleChevronDown from "./double-chevron-down";
import DoubleChevronDownFlat from "./double-chevron-down-flat";
import DoubleChevronLeft from "./double-chevron-left";
import DoubleChevronLeftFlat from "./double-chevron-left-flat";
import DoubleChevronRight from "./double-chevron-right";
import DoubleChevronRightFlat from "./double-chevron-right-flat";
import DoubleChevronUp from "./double-chevron-up";
import DoubleChevronUpFlat from "./double-chevron-up-flat";
import Download from "./download";
import DragHandler from "./drag-handler";
import Drainage from "./drainage";
import DuofreshSticks from "./duofresh-stick";
import Duration from "./duration";
import Edit from "./edit";
import EmptyPipe from "./empty-pipe";
import Enter from "./enter";
import Envelope from "./envelope";
import Error1 from "./error1";
import Error2 from "./error2";
import Ethernet from "./ethernet";
import ExitFullscreen from "./exit-fullscreen";
import Export from "./export";
import Eye from "./eye";
import EyeHide from "./eye-hide";
import Facebook from "./facebook";
import FailedConnection from "./failed-connection";
import Fan from "./fan";
import FanMax from "./fan-max";
import FanMin from "./fan-min";
import FavouriteFilled from "./favourite-filled";
import FavouriteOutlined from "./favourite-outlined";
import Filter from "./filter";
import FilterChange from "./filter-change";
import Flush from "./flush";
import FlushMax from "./flush-max";
import FlushMin from "./flush-min";
import FlushOff from "./flush-off";
import Folder from "./folder";
import Forwards from "./forwards";
import Forwards5s from "./forwards-5s";
import Fullscreen from "./fullscreen";
import GalleryView from "./gallery-view";
import Gateway from "./gateway";
import GeberitID from "./geberit-id";
import GeBus from "./ge-bus";
import Globe from "./globe";
import Google from "./google";
import GroupAction from "./group-action";
import Headset from "./headset";
import Help from "./help";
import Home from "./home";
import Image from "./image";
import Images from "./images";
import Import from "./import";
import Instagram from "./instagram";
import Installation from "./installation";
import IotSensor from "./iot-sensor";
import Lightbulb from "./lightbulb";
import LikeFilled from "./like-filled";
import LikeOutlined from "./like-outlined";
import Link from "./link";
import Linkedin from "./linkedin";
import LinkTo from "./link-to";
import Lists from "./lists";
import ListView from "./list-view";
import Locate from "./locate";
import Location from "./location";
import Lock from "./lock";
import LogFile from "./log-file";
import LogOut from "./log-out";
import Manual from "./manual";
import Menu from "./menu";
import Minimize from "./minimize";
import Minus from "./minus";
import MobileDevice from "./mobile-device";
import MoreLarge from "./more-large";
import MoreSmall from "./more-small";
import MoveFolder from "./move-folder";
import Movie from "./movie";
import MP3 from "./mp3";
import MP4 from "./mp4";
import NewFile from "./new-file";
import News from "./news";
import Onlineshop from "./onlineshop";
import OpenCamera from "./open-camera";
import Pause from "./pause";
import Pdf from "./pdf";
import Pen from "./pen";
import Pinterest from "./pinterest";
import Play from "./play";
import Presets from "./presets";
import Print from "./print";
import Profile from "./profile";
import Redo from "./redo";
import Refresh from "./refresh";
import Remote from "./remote";
import RemoteMaintenance from "./remote-maintenance";
import RemoteSmall from "./remote-small";
import Reset from "./reset";
import ReturnGoods from "./return-goods";
import Ruler from "./ruler";
import SampleCatalogue from "./sample-catalogue";
import SanitaryFlush from "./sanitary-flush";
import Save from "./save";
import Search from "./search";
import Select from "./select";
import SelectOff from "./select-off";
import SelectOn from "./select-on";
import Send from "./send";
import Sensor from "./sensor";
import SensorMax from "./sensor-max";
import SensorMin from "./sensor-min";
import Service from "./service";
import Settings from "./settings";
import Share from "./share";
import Smartphone from "./smartphone";
import SortAscending from "./sort-ascending";
import SortDescending from "./sort-descending";
import Spinner from "./spinner";
import Stats from "./stats";
import Stethoscope from "./stethoscope";
import Stop from "./stop";
import Store from "./store";
import Tap from "./tap";
import TargetGroup from "./target-group";
import Telephone from "./telephone";
import Temperature from "./temperature";
import TemperatureDown from "./temperature-down";
import TemperatureUp from "./temperature-up";
import ToiletControlRectangle from "./toilet-control-rectangular";
import ToiletControlRound from "./toilet-control-round";
import Touch from "./touch";
import Touchless from "./touchless";
import Trash from "./trash";
import TruncationPagination from "./truncation-pagination";
import Undo from "./undo";
import UnknownProduct from "./unknown-product";
import Unlock from "./unlock";
import Update from "./update";
import Upload from "./upload";
import Urinal from "./urinal";
import UserLoggedOff from "./user-logged-off";
import UserLoggedOn from "./user-logged-on";
import View3d from "./view-3d";
import ViewDocument from "./view-document";
import VolumeLouder from "./volume-louder";
import VolumeMute from "./volume-mute";
import VolumeQuieter from "./volume-quieter";
import WarningInfo from "./warning-info";
import WarningModerate from "./warning-moderate";
import WarningSevere from "./warning-severe";
import Washplace from "./washplace";
import WaterSupply from "./water-supply";
import WebApplication from "./web-application";
import WhatsApp from "./whatsApp";
import Wifi from "./wifi";
import Wired from "./wired";
import Wireless from "./wireless";
import X from "./x";
import Xing from "./xing";
import XLS from "./xls";
import Youtube from "./youtube";
import Zip from "./zip";
import ZoomIn from "./zoom-in";
import ZoomOut from "./zoom-out";
import { changedIcons } from "./changed";
export const icons = Object.assign(Object.assign({}, changedIcons), { activity_indicator: ActivityIndicator, add: Add, added_to_list: AddedToList, apple: Apple, aquaclean: Aquaclean, arrow_bottom_left: ArrowBottomLeft, arrow_bottom_right: ArrowBottomRight, arrow_down: ArrowDown, arrow_left: ArrowLeft, arrow_right: ArrowRight, arrow_top_left: ArrowTopLeft, arrow_top_right: ArrowTopRight, arrow_up: ArrowUp, attachment: Attachment, available_seats: AvailableSeats, backwards_5s: Backwards5s, backwards: Backwards, bath_planner: BathPlanner, bath: Bath, battery_empty: BatteryEmpty, battery_full: BatteryFull, battery_low: BatteryLow, battery_ok: BatteryOk, battery: Battery, bluetooth: Bluetooth, bms_smart_home: BmsSmartHome, bookmark_filled: BookmarkFilled, bookmark_outlined: BookmarkOutlined, brightness_max: BrightnessMax, brightness_min: BrightnessMin, brush: Brush, cad: CAD, calendar: Calendar, catalogue: Catalogue, categories: Categories, category_select: CategorySelect, cellular_network: CellularNetwork, chat: Chat, checklist: Checklist, checkmark_filled: CheckmarkFilled, checkmark: Checkmark, chevron_down_flat: ChevronDownFlat, chevron_down: ChevronDown, chevron_left_flat: ChevronLeftFlat, chevron_left: ChevronLeft, chevron_right_flat: ChevronRightFlat, chevron_right: ChevronRight, chevron_up_flat: ChevronUpFlat, chevron_up: ChevronUp, cleaning: Cleaning, clock: Clock, close: Close, cloud: Cloud, content_copy: ContentCopy, content_paste: ContentPaste, converter: Converter, cost_per_person: CostPerPerson, create_group: CreateGroup, csv_file: CsvFile, cut: Cut, datapoints: Datapoints, descaling: Descaling, dislike_filled: DislikeFilled, dislike_outlined: DislikeOutlined, document: Document, double_chevron_down_flat: DoubleChevronDownFlat, double_chevron_down: DoubleChevronDown, double_chevron_left_flat: DoubleChevronLeftFlat, double_chevron_left: DoubleChevronLeft, double_chevron_right_flat: DoubleChevronRightFlat, double_chevron_right: DoubleChevronRight, double_chevron_up_flat: DoubleChevronUpFlat, double_chevron_up: DoubleChevronUp, download: Download, drag_handler: DragHandler, drainage: Drainage, duofresh_sticks: DuofreshSticks, duration: Duration, edit: Edit, empty_pipe: EmptyPipe, enter: Enter, envelope: Envelope, error1: Error1, error2: Error2, ethernet: Ethernet, exit_fullscreen: ExitFullscreen, export: Export, eye_hide: EyeHide, eye: Eye, facebook: Facebook, failed_connection: FailedConnection, fan_max: FanMax, fan_min: FanMin, fan: Fan, favourite_filled: FavouriteFilled, favourite_outlined: FavouriteOutlined, filter_change: FilterChange, filter: Filter, flush_max: FlushMax, flush_min: FlushMin, flush_off: FlushOff, flush: Flush, folder: Folder, forwards_5s: Forwards5s, forwards: Forwards, fullscreen: Fullscreen, gallery_view: GalleryView, gateway: Gateway, geberit_id: GeberitID, gebus: GeBus, globe: Globe, google: Google, group_action: GroupAction, headset: Headset, help: Help, home: Home, image: Image, images: Images, import: Import, instagram: Instagram, installation: Installation, iot_sensor: IotSensor, lightbulb: Lightbulb, like_filled: LikeFilled, like_outlined: LikeOutlined, link_to: LinkTo, link: Link, linkedin: Linkedin, list_view: ListView, lists: Lists, locate: Locate, location: Location, lock: Lock, log_file: LogFile, log_out: LogOut, manual: Manual, menu: Menu, minimize: Minimize, minus: Minus, mobile_device: MobileDevice, more_large: MoreLarge, more_small: MoreSmall, move_folder: MoveFolder, movie: Movie, mp3: MP3, mp4: MP4, new_file: NewFile, news: News, onlineshop: Onlineshop, open_camera: OpenCamera, pause: Pause, pdf: Pdf, pen: Pen, pinterest: Pinterest, play: Play, presets: Presets, print: Print, profile: Profile, redo: Redo, refresh: Refresh, remote_maintenance: RemoteMaintenance, remote_small: RemoteSmall, remote: Remote, reset: Reset, return_goods: ReturnGoods, ruler: Ruler, sample_catalogue: SampleCatalogue, sanitary_flush: SanitaryFlush, save: Save, search: Search, select_off: SelectOff, select_on: SelectOn, select: Select, send: Send, sensor_max: SensorMax, sensor_min: SensorMin, sensor: Sensor, service: Service, settings: Settings, share: Share, smartphone: Smartphone, sort_ascending: SortAscending, sort_descending: SortDescending, spinner: Spinner, stats: Stats, stethoscope: Stethoscope, stop: Stop, store: Store, tap: Tap, target_group: TargetGroup, telephone: Telephone, temperature_down: TemperatureDown, temperature_up: TemperatureUp, temperature: Temperature, toilet_control_rectangle: ToiletControlRectangle, toilet_control_round: ToiletControlRound, touch: Touch, touchless: Touchless, trash: Trash, truncation_pagination: TruncationPagination, undo: Undo, unknown_product: UnknownProduct, unlock: Unlock, update: Update, upload: Upload, urinal: Urinal, user_logged_off: UserLoggedOff, user_logged_on: UserLoggedOn, view_3d: View3d, view_document: ViewDocument, volume_louder: VolumeLouder, volume_mute: VolumeMute, volume_quieter: VolumeQuieter, warning_info: WarningInfo, warning_moderate: WarningModerate, warning_severe: WarningSevere, washplace: Washplace, water_supply: WaterSupply, web_application: WebApplication, whatsapp: WhatsApp, wifi: Wifi, wired: Wired, wireless: Wireless, x: X, xing: Xing, xls: XLS, youtube: Youtube, zip: Zip, zoom_in: ZoomIn, zoom_out: ZoomOut });
export default icons;
